import type { ReactNode } from "react";

interface ExclusiveCarouselHeaderProps {
	mobileTitle: string;
	desktopTitle: string;
	navigation: ReactNode;
}

export function ExclusiveCarouselHeader({
	mobileTitle,
	desktopTitle,
	navigation,
}: ExclusiveCarouselHeaderProps) {
	return (
		<div className="relative mb-4 flex items-center gap-1 md:mb-3.5 md:justify-between md:gap-2">
			<h2 className="min-w-0 text-h5 break-words text-gray-700 md:hidden">
				{mobileTitle}
			</h2>
			<h2 className="hidden min-w-0 text-body-lg-emphasis break-words text-gray-700 md:block">
				{desktopTitle}
			</h2>
			{navigation}
		</div>
	);
}
